module.exports = __webpack_public_path__ + "img/ic_yuncangjieshao@2x.33b9e3c9.png";